import { Button, Input, Space, Table, TableColumnType } from "antd";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IPurchaseFilter, IPurchaseOrder } from "../../models/Purchase";
import { useGetPurchaseOrder } from "../../query/PurchaseQuery";

const PurchaseOrder = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<IPurchaseFilter>({
    page: 1,
    limit: 10,
  });
  const { data, isLoading } = useGetPurchaseOrder(filter);
  // eslint-disable-next-line
  const handleSearchPONumber = useCallback(
    debounce((value: string) => {
      setFilter((prev: IPurchaseFilter) => ({
        ...prev,
        poNumber: value,
      }));
    }, 1000),
    [],
  );

  const column: TableColumnType<IPurchaseOrder>[] = [
    {
      title: "Mã đơn hàng",
      dataIndex: "pONumber",
      key: "pONumber",
      align: "center",
      filterDropdown: () => (
        <Input
          placeholder="Tìm kiếm theo mã đơn hàng"
          onChange={(e) => handleSearchPONumber(e.target.value)}
        />
      ),
    },
    {
      title: "Nhà cung cấp",
      dataIndex: "vendorName",
      key: "vendorName",
      align: "center",
    },
    {
      title: "Ngày đặt hàng",
      dataIndex: "orderDate",
      key: "orderDate",
      align: "center",
    },
    {
      title: "Ngày giao hàng (ước tính)",
      dataIndex: "expectedDeliveryDate",
      key: "expectedDeliveryDate",
      align: "center",
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value: string) => {
        switch (value) {
          case "DRAFT":
            return "Nháp";
          case "SENT":
            return "Đã gửi";
          case "PARTIALLY_RECEIVED":
            return "Đã nhận một phần";
          case "COMPLETED":
            return "Hoàn thành";
          default:
            return "Đã huỷ";
        }
      },
    },
    {
      title: "Phí tax (%)",
      dataIndex: "importTaxPercent",
      key: "importTaxPercent",
      align: "center",
    },
    {
      title: "Tổng tiền (VND)",
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "center",
      render: (value: number) => {
        return new Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(value);
      },
    },
    {
      title: "Tổng tiền (USD)",
      dataIndex: "totalAmountUsd",
      key: "totalAmountUsd",
      align: "center",
    },
    {
      title: "Phí ship (VND)",
      dataIndex: "shippingCharge",
      key: "shippingCharge",
      align: "center",
      render: (value: number) => {
        return new Intl.NumberFormat("vi-VN", {
          style: "currency",
          currency: "VND",
        }).format(value);
      },
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "note",
      align: "center",
    },
    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      align: "center",
      render: (value, record) => (
        <Space>
          <Button type="link" onClick={() => navigate(`./${record.pONumber}`)}>
            Chi tiết
          </Button>
        </Space>
      ),
    },
  ];
  return (
    <div className="p-4">
      <Table
        dataSource={data?.data}
        columns={column}
        loading={isLoading}
        pagination={{
          current: data?.pagination.page,
          pageSize: data?.pagination.limit,
          total: data?.pagination.total,
          onChange: (page, pageSize) => {
            setFilter({
              ...filter,
              page: page,
              limit: pageSize,
            });
          },
        }}
      />
    </div>
  );
};

export default PurchaseOrder;
